import AuditLogs from "./AuditLogs";

const AccountLogs = () => {
     return (
          <AuditLogs log="transfer" title="Log des transactions 2PC"
               routeSegment={[{ name: 'Transfert Logs' }, { name: 'Log des transactions 2PC', path: '/logs/transfer' }]} />
     )
}
export default AccountLogs;
